import { ConfirmationDialog, IconButton, Id, useOpen } from "@dgs/core";
import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import { DataFieldOptionOrderIndexResource } from "../../../shared/types/dataFieldOption";
import { ListItem } from "../shared/ui/sortable_lists/ListItem";

interface Props {
	item: DataFieldOptionOrderIndexResource;
	onEditClick: (id: Id) => void;
	onDeleteClick: (id: Id) => void;
	disabled: boolean;
}

const ButtonContainer = styled.div`
	display: flex;
	gap: ${({ theme }) => theme.spacing(2)};
`;
const ListItemContent = styled.div`
	display: flex;
	justify-content: space-between;
	align-items: center;
	flex: 1;
`;

export function SortableItem({ item, onEditClick, onDeleteClick, disabled }: Props) {
	const { attributes, listeners, setNodeRef, transform, transition } = useSortable({
		id: item.id,
		disabled,
	});
	const { t } = useTranslation();
	const { open, handleClose, handleOpen } = useOpen();
	const style = {
		transform: CSS.Transform.toString(transform),
		transition,
	};

	return (
		<>
			<ListItem
				disabled={disabled}
				isFallback={item.isFallback}
				ref={setNodeRef}
				style={style}
				{...attributes}
				{...listeners}
			>
				<ListItemContent>
					{item.value}
					<ButtonContainer>
						<IconButton size="small" type="button" title={t("Edit")} onClick={() => onEditClick(item.id)} icon="edit" />
						<IconButton size="small" type="button" title={t("Delete")} onClick={handleOpen} icon="delete" />
					</ButtonContainer>
				</ListItemContent>
			</ListItem>
			<ConfirmationDialog
				open={open}
				onClose={handleClose}
				action={() => onDeleteClick(item.id)}
				heading={t("Delete data field option")}
				labels={{ close: t("Close"), confirm: t("Confirm") }}
			>
				{t("Are you sure you want to remove this data field option?")}
			</ConfirmationDialog>
		</>
	);
}
